import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatabaseService } from '../_services/database.service';
import { SnackBarOverview } from '../Toast';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-feedbackform',
  templateUrl: './feedbackform.component.html',
  styleUrls: ['./feedbackform.component.scss']
})
export class FeedbackformComponent implements OnInit {
  id: any;
  addCustomerForm: FormGroup;
  flag = 0;
  submitted = false;
  constructor(public service: DatabaseService, public rout: Router, public route: ActivatedRoute, public toast: SnackBarOverview, private formBuilder: FormBuilder) {
    // Removed direct snapshot extraction; will handle in ngOnInit
  }


  ngOnInit() {
    // Extract complaint ID from route param or fragment, handling encoded characters and # tags
    const paramId = this.route.snapshot.paramMap.get('id');
    const fragment = this.route.snapshot.fragment;
    let extractedId: number | null = null;

    if (paramId) {
      const decodedParam = decodeURIComponent(paramId);
      const matchParam = decodedParam.match(/\d+/);
      if (matchParam) {
        extractedId = Number(matchParam[0]);
      }
    }

    if (!extractedId && fragment) {
      const decodedFrag = decodeURIComponent(fragment);
      const matchFrag = decodedFrag.match(/\d+/);
      if (matchFrag) {
        extractedId = Number(matchFrag[0]);
      }
    }

    this.id = extractedId;
    console.log('Extracted complaint ID:', this.id);

    // Initialize the form
    this.addCustomerForm = this.formBuilder.group({
      cust_name: ['', Validators.required],
      id_text: [''],
      cust_contact: ['', Validators.required],
      type: [''],
      feedback: ['', Validators.required],
      feedback_remark: ['', Validators.required]
    });

    // Fetch complaint details now that ID (if any) is set
    this.getComplaintDetails();
  }

  get e() {
    return this.addCustomerForm.controls;
  }

  charonly(event: any) {
    const pattern = /^[a-zA-Z ]+$/;
    let inputChar = String.fromCharCode(event.charCode); if (event.keyCode != 8 && !pattern.test(inputChar)) { event.preventDefault(); }
  }
  MobileNumber2(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode); if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  submitCustomer() {
    this.submitted = true;
    this.flag = 0;
    // console.log('test');
    if (this.addCustomerForm.invalid) {
      this.toast.openError('Please fill all mandatory fields', 'Error');
      return;
    }
    const formData = this.addCustomerForm.value;
    // Use cleaned numeric complaint ID
    formData['complaint_id'] = this.id;
    console.log(formData);
    this.service.FetchData2(formData, 'complaint/saveFeedback').subscribe((result) => {
      console.log(result);
      if (result['message'] === 'Success') {
        this.toast.openSucess('Feedback submitted successfully', 'Success');
        this.rout.navigate(['/']);
      } else {
        this.toast.openError('Error submitting feedback', 'Error');
      }
    });

  }

  getComplaintDetails() {
    if (!this.id) {
      console.error('Complaint ID is not available');
      return;
    }
    // Use consistent key name for complaint ID in the payload
    this.service.FetchData2({ 'complaint_id': this.id, 'comp_id': this.id }, 'complaint/feedback_complaint_details').subscribe((result: any) => {
      console.log('API Response:', result);

      let data = result;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (e) { }
      }

      if (data && data.data) {
        data = data.data;
      }
      if (data && data.detail) {
        data = data.detail;
      }

      if (Array.isArray(data) && data.length > 0) {
        data = data[0];
      }

      if (data) {
        console.log('Extracted Data Object:', data);

        const cust_name = data.cust_name || data.customer_name || '';
        const customer_code = data.id_text || data.customer_code || data.cust_code || '';
        const contact = data.cust_contact || data.contact_no || data.contact || '';
        const issue_category = data.type || data.issue_category || '';

        console.log('Values to patch:', { cust_name, customer_code, contact, issue_category });

        // Explicitly set each control's value to bypass patchValue quirks
        if (this.addCustomerForm.get('cust_name')) this.addCustomerForm.get('cust_name').setValue(cust_name);
        if (this.addCustomerForm.get('id_text')) this.addCustomerForm.get('id_text').setValue(customer_code);
        if (this.addCustomerForm.get('cust_contact')) this.addCustomerForm.get('cust_contact').setValue(contact);
        if (this.addCustomerForm.get('type')) this.addCustomerForm.get('type').setValue(issue_category);

        // Update value and validity to force the form to reflect changes
        this.addCustomerForm.updateValueAndValidity();
      } else {
        console.log('Data object is empty or undefined');
      }
    });
  }
}